import { api } from "@/api";
import { MutationConfig, MutationResult } from "@/shared/types/base";
import { ArticuloMovimiento, ArticuloMovimientoTipo } from "@/shared/types/articulo-movimiento";
import { sleep } from "@/shared/utils";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { ReactNode } from "react";

export interface ArticuloMovimientoRequest {
    fecha?: string;
    tipo: ArticuloMovimientoTipo,
    descripcion: string;
    articuloId: string;
    cantidad: number;
}

export async function addArticuloMovimiento(request: ArticuloMovimientoRequest): Promise<ArticuloMovimiento> {
    await sleep(1000);
    const response = await api.post("articulo_movimientos", request);
    return response.data;
}

export function useAddArticuloMovimientoMutation(mutationConfig: MutationConfig<ArticuloMovimiento, ArticuloMovimientoRequest> = {}) {
    const queryClient = useQueryClient();
    return useMutation({
        ...mutationConfig,
        mutationFn: addArticuloMovimiento,
        onSuccess: (...args) => {
            mutationConfig.onSuccess && mutationConfig.onSuccess(...args);
            queryClient.invalidateQueries({ queryKey: ["articulo_movimientos"] });
        },
    })
}

export interface AddArticuloMovimientoMutationProps {
    mutationConfig?: MutationConfig<ArticuloMovimiento, ArticuloMovimientoRequest>
    children?: (mutationResult: MutationResult<ArticuloMovimiento, ArticuloMovimientoRequest>) => ReactNode
}

export function AddArticuloMovimientoMutation({
    mutationConfig,
    children
}: AddArticuloMovimientoMutationProps) {
    const mutationResult = useAddArticuloMovimientoMutation(mutationConfig);
    return children && children(mutationResult);
}